// extracted by mini-css-extract-plugin
export var searchResults = "styles-module--search-results--8ccf9";
export var searchResults__end = "styles-module--search-results__end--b0c47";
export var searchResults__product = "styles-module--search-results__product--aba61";